/* oxlint-disable react-hooks-js/immutability */
/* eslint-disable react-hooks/immutability */

import { useTranslation } from '@mint-lib/i18n';
import { useSnapshot } from 'valtio';

import {
  useActivitiesListQuery,
  useMediaPlansListQuery,
  usePlatformsOfActivity,
} from '../../../queries/index.js';
import { Combobox } from '../../atoms/Combobox.jsx';
import { isPlatformFieldRequiredForTemplateDuplicate } from './isPlatformFieldRequiredForTemplateDuplicate.js';
import type { TemplateDuplicationFormState } from './types.js';

type ContextFieldsProps = {
  state: TemplateDuplicationFormState;
};

export const TemplateContextFieldsV2 = ({ state }: ContextFieldsProps) => {
  const { t } = useTranslation('@myn/import-hub');

  const snap = useSnapshot(state);

  const shouldShowPlatformField = isPlatformFieldRequiredForTemplateDuplicate(
    snap.form.granularityLevel,
  );

  const { data: mediaPlansList = [], isLoading: mediaPlansListIsLoading } =
    useMediaPlansListQuery();

  const { data: activitiesList = [], isLoading: activitiesListIsLoading } =
    useActivitiesListQuery(snap.form.mediaPlanId);

  const {
    data: platformsOfActivity = [],
    isLoading: platformsOfActivityIsLoading,
    noOptionsText: platformsNoOptionsText,
  } = usePlatformsOfActivity(
    snap.form.activityId as string,
    snap.form.granularityLevel,
  );

  const platformNameFieldValue = platformsOfActivity.find(
    ({ id }) => String(id) === String(snap.form.platformName),
  );

  return (
    <>
      <Combobox
        withSearch
        label={t('Media plan*')}
        placeholder={t('Select')}
        inputValue={snap.form.mediaPlanName}
        options={mediaPlansList}
        isLoading={mediaPlansListIsLoading}
        getOptionLabel={(option) => option.name}
        getOptionValue={(option) => String(option.id)}
        onChange={(option) => {
          state.form.mediaPlanId = option.id;
          state.form.mediaPlanName = option.name;
          state.form.activityId = null;
          state.form.activityName = null;
          state.form.platformName = null;
        }}
        inputProps={{ autoComplete: 'off' }}
      />
      <Combobox
        withSearch
        label={t('Activity*')}
        placeholder={t('Select')}
        inputValue={snap.form.activityName}
        options={activitiesList}
        isLoading={activitiesListIsLoading}
        getOptionLabel={(option) => option.name}
        getOptionValue={(option) => String(option.id)}
        onChange={(option) => {
          state.form.activityId = option.id;
          state.form.activityName = option.name;
          state.form.platformName = null;
        }}
        disabled={!snap.form.mediaPlanId}
        inputProps={{ autoComplete: 'off' }}
      />
      {shouldShowPlatformField && (
        <Combobox
          withSearch
          label={t('Platform*')}
          placeholder={t('Select')}
          inputValue={platformNameFieldValue?.name ?? null}
          options={platformsOfActivity}
          isLoading={platformsOfActivityIsLoading}
          noOptionsText={platformsNoOptionsText}
          getOptionLabel={(option) => option.name}
          getOptionValue={(option) => String(option.id)}
          onChange={(option) => {
            state.form.platformName = option.id;
          }}
          disabled={!snap.form.activityId}
          inputProps={{ autoComplete: 'off' }}
        />
      )}
    </>
  );
};
